import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

const getClientById = clientId => {
  const query = `
    query ($clientId: ID!){
        clientHasAccessToSelfServe(clientId: $clientId)
    }
  `
  const params = { clientId }
  return callAuthorizedGraphQLEndpoint(query, params)
}

const createSSCampaign = input => {
  const query = `
    mutation createSSCampaign($input: CreateSSCampaignInput!){
        createSSCampaign(input: $input){
          campaignId
          clientId
        }
    }
  `
  return callAuthorizedGraphQLEndpoint(query, { input })
}

const duplicateUSEDDMCampaign = input => {
  const query = `
    mutation duplicateUSEDDMCampaign($input: DuplicateUSEDDMCampaignInput!){
        duplicateUSEDDMCampaign(input: $input){
          campaignId
          clientId
          success
          error
        }
    }
  `
  return callAuthorizedGraphQLEndpoint(query, { input })
}

const getCountryDefaultSettings = async ({ countryId }) => {
  const query = `query ($countryId: ID!) {
    country (id: $countryId) {
      countryDefaultSettings {
        baPerLocation
        enabledChannelBroadAreas,
        enabledChannelPreciseLocations,
        enabledChannelLetterbox
        enabledChannelEddm,
        enabledChannelAdm
      }
    }
  }`

  const req = await callAuthorizedGraphQLEndpoint(query, { countryId })
  const {
    data: {
      country: { countryDefaultSettings },
    },
  } = await req.json()

  return countryDefaultSettings
}

export {
  getClientById,
  createSSCampaign,
  duplicateUSEDDMCampaign,
  getCountryDefaultSettings,
}
